import {Box, Typography} from "@mui/material";

// Shared field chrome for the campaign form: flat, borderless, rounded inputs — matches the rest of
// the registry project (InputBase + controlSx pattern), not MUI's default bordered TextField.
export const controlSx = {
  height: 40, display: "flex", alignItems: "center", gap: 1, px: 1.25,
  borderRadius: "10px", bgcolor: "#FAFAFD", color: "#6B6B80", fontSize: 13,
};

export const FieldLabel = ({children, required}) => (
  <Typography sx={{fontSize: 12, fontWeight: 600, color: "#6B6B80", mb: 0.75, textTransform: "uppercase", letterSpacing: "0.05em"}}>
    {children}{required && <Box component="span" sx={{color: "#DC2626"}}> *</Box>}
  </Typography>
);

export const FieldHelper = ({error, children}) => (
  <Typography sx={{fontSize: 12, color: error ? "#DC2626" : "#8A8AA0", mt: 0.5}}>{children}</Typography>
);

export const selectSx = {
  ...controlSx,
  width: "100%",
  "&:hover": {bgcolor: "#ECECF3"},
  "& .MuiOutlinedInput-notchedOutline": {border: "none"},
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {border: "none"},
  "& .MuiSelect-select": {display: "flex", alignItems: "center", py: "0 !important", pl: "12px !important", pr: "30px !important", minHeight: "0 !important"},
  "& .MuiSelect-icon": {color: "#6B6B80"},
};
